/** ========================================================= * Material Kit 2 PRO React - v2.0.0 ========================================================= * Product Page: https://www.creative-tim.com/product/material-kit-pro-react * Copyright 2021 Creative Tim (https://www.creative-tim.com) Coded by www.creative-tim.com ========================================================= * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software. */

// next
import dynamic from "next/dynamic";
import Image from 'next/image';

// font
import { robotoSlab } from "/utils/fonts";

// MUI
const Card = dynamic(() => import("@mui/material/Card"), { loading: () => null });
const Link = dynamic(() => import("@mui/material/Link"), { loading: () => null });

// PRO
const MDBox = dynamic(() => import('/components/MDBox'), { loading: () => null });
const MDButton = dynamic(() => import('/components/MDButton'), { loading: () => null });
const MDTypography = dynamic(() => import('/components/MDTypography'), { loading: () => null });

function DefaultBackgroundCard({ image, label, title, description, action }) {
  return (
    <Card
      sx={({
        functions: { rgba, linearGradient },
        palette: { black },
        borders: { borderRadius },
      }) => ({
        backgroundImage: `${linearGradient(
          rgba(black.main, 0.5),
          rgba(black.main, 0.5)
        )})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: borderRadius.xl,
      })}
    >
      <Image
        src={image}
        alt="map showing Autumn Leaf's location"
        quality={50}
        fill
        sizes="(max-width: 768px) 80vw, 25vw"
      />
      <MDBox
        position="absolute"
        width="100%"
        height="100%"
        top={0}
        left={0}
        zIndex={2}
        sx={({
          palette: { black },
          borders: { borderRadius },
        }) => ({
          backgroundImage: ({ functions: { linearGradient, rgba } }) =>
            `${linearGradient(
              rgba(black.main, 0.5),
              rgba(black.main, 0.5)
            )}`,
          backgroundSize: "cover",
          backgroundSize: "cover",
          backgroundPosition: "center",
          borderRadius: borderRadius.xl,
        })}

      />
      <MDBox textAlign="center" pt={12} pb={8.5} px={3} zIndex={2} position="relative">
        {label && (
          <MDTypography variant="body2" color="white" textTransform="uppercase" mb={2}>
            {label}
          </MDTypography>
        )}
        <MDTypography variant="h3" color="white" className={robotoSlab.className}>
          {title}
        </MDTypography>
        <MDTypography variant="body2" color="white" opacity={0.8} mb={2}>
          {description}
        </MDTypography>
        {action.type === "internal" ? (
          <MDButton component={Link} to={action.route} color="white" size="small" sx={{ my: 2 }}>
            {action.label}
          </MDButton>
        ) : (
          <MDButton
            component="a"
            href={action.route}
            target="_blank"
            rel="noreferrer"
            color="white"
            size="small"
            sx={{ my: 2 }}
          >
            {action.label}
          </MDButton>
        )}
      </MDBox>
    </Card>
  );
}

export default DefaultBackgroundCard;
